import React, { ReactNode, useContext, useEffect, useState } from 'react';
import OdometerTags from "../layout/Odometer";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectCoverflow, Navigation, Pagination } from "swiper";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import Footer from "./footer";

import useInterval from "../../hooks/useInterval";
import MainGameListLayout from "../list/main_game_list_layout";
import { with_comma } from "../../util/comma";
import moment from "moment";
import api from "../../util/api";
import { Player } from '@lottiefiles/react-lottie-player';
import loading from "../../_asset/lottie/loading_2.json"
import ReplayModalIframe from "../layout/replay_modal_iframe";
import { PrivateUser } from "../../hooks/useUser";
import { UserContext } from "../../apps/_root";
import { actionContext } from "../../apps/page";
import licenseBanner from "../../_asset/banner/License_banner_1.png"
import licenseBanner_pragmatic from "../../_asset/banner/banner_pragmatic.png"
import licenseBanner_evolution from "../../_asset/banner/banner_evolution.png"
import LicenseBannerPopup from '../banner/license';
import { lobbyModalContext } from '../provider/lobby_modal_provider';
import { sexyVendor } from '../../data/gameData_casino';
import BannerSwiper from '../banner/bannerSwiper';
import LicenseBannerPopupEvolution from '../banner/license_evolution';


function Main() {
    return (
        <main id={`main`}>
            <div className={`margin-container`}>
                <BannerSwiper />
                <div className={'list-layouts'} >
                    {/* <JackpotLayout/> */}
                    <LicenseLayout >
                        <RealTimeDepositList />
                        <RealtimeJackPotList />
                    </LicenseLayout>
                    {/*<NoticeLayout/>*/}
                </div>
                <MainGameListLayout />

                <Footer />
            </div>
        </main>
    );
}

export default Main;

function LicenseLayout({ children }: { children: ReactNode }) {
    const { User } = useContext(UserContext)
    const { SetLoginPop } = useContext(actionContext)
    const [popShow, setPopShow] = useState<boolean>(false)
    const [popShowEvolution, setPopShowEvolution] = useState<boolean>(false)
    return (
        <>
            <div className='license-image' >
                <img src={licenseBanner_pragmatic} alt="license" onClick={e => {
                    if(User.is_authenticated){
                        setPopShow(true)
                    }else{
                        SetLoginPop()
                    }
                }} />
            </div>
            {children}
            <div className='license-image' >
                <img src={licenseBanner_evolution} alt="license" onClick={e => {
                    if(User.is_authenticated){
                        setPopShowEvolution(true)
                    }else{
                        SetLoginPop()
                    }
                }} />
            </div>
            <LicenseBannerPopup popShow={popShow} setPopShow={setPopShow} />
            <LicenseBannerPopupEvolution popShow={popShowEvolution} setPopShow={setPopShowEvolution} />
        </>
    )
}

function JackpotLayout() {
    const [odometerNumber, setOdometerNumber] = useState<number>(0)

    useEffect(() => {
        let setOdometerDefaultNumber = Math.floor(Math.random() * 1000000000)
        while (setOdometerDefaultNumber < 100000000) {
            setOdometerDefaultNumber = Math.floor(Math.random() * 1000000000)
        }
        setOdometerNumber(setOdometerDefaultNumber)
    }, [])
    useInterval(() => {
        let random_count = Math.floor(Math.random() * 100)
        setOdometerNumber(odometerNumber + random_count)
    }, 900)
    return (
        <div className={'jackpot-layout'}>
            <div className={"jackpot-frame"}></div>
            <p className={'jackpot-text'}>PROGRESSIVE JACKPOT</p>
            <div className={'jackpot-inner'}>
                <div className={'inner-line-out'}></div>
                <div className={'inner-dot'}></div>
                <div className={'inner-line-inner'}></div>
                <OdometerTags odometerNumber={odometerNumber} />
            </div>
        </div>
    )
}

function getAlphabetNumberArr() {
    const alphabet = `abcdefghijklmnopqrstuvwxyz`;
    const alphabetArr = [];
    for (let i = 0; i < alphabet.length + 10; i++) {
        if (i < alphabet.length) {
            alphabetArr[i] = alphabet.slice(i, i + 1);
        } else {
            alphabetArr[i] = `${i - 26}`
        }
    }
    return alphabetArr
}
function rand(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
interface RealTimeDepositListInterface {
    "kind": string,
    "amount": number,
    "user": string,
    "processed_at": string
}
function RealTimeDepositList() {
    const [depositList, setDepositList] = useState<RealTimeDepositListInterface[]>()
    // const depositCostTemplate = [10000, 50000, 100000, 500000]

    function updateList() {
        api(`/api/wallet/live_depositwithdrawals/`)
            .then(res => res.json())
            .then((data: RealTimeDepositListInterface[]) => {
                setDepositList(data)
            })
    }
    useEffect(() => {
        updateList()
    }, [])
    useInterval(() => {
        updateList()
    }, 60000)
    return (
        <div className={'list-layout realtime-deposit-layout'}>
            <div className={'frame'}></div>
            <header>실시간 <span>입출금</span> 현황</header>
            {
                depositList
                    ? <Swiper
                        direction={'vertical'}
                        // spaceBetween={5}
                        autoplay={{
                            delay: 1500
                        }}
                        freeMode={true}
                        loop={true}
                        slidesPerView={4}
                        className={'list-main realtime-deposit-list'}
                        modules={[Autoplay]}
                    >
                        {
                            depositList.map((list, index) => {
                                const oddEven = index % 2 ? `odd` : `even`
                                return (
                                    <SwiperSlide key={index} className={`list-item ${oddEven}`}>
                                        <RealTimeDepositItem list={list} />
                                    </SwiperSlide>
                                )
                            })
                        }
                        {
                            depositList.length > 5 && depositList.length < 9
                                ? depositList.map((list, index) => {
                                    const oddEven = index % 2 ? `odd` : `even`
                                    return (
                                        <SwiperSlide key={index} className={`list-item ${oddEven}`}>
                                            <RealTimeDepositItem list={list} />
                                        </SwiperSlide>
                                    )
                                })
                                : <></>
                        }
                    </Swiper>
                    : <div className={'list-main realtime-deposit-list'}>
                        <Player src={loading}
                            autoplay
                            loop
                            style={{ width: "50%", height: "50%" }}
                        ></Player>
                    </div>
            }
        </div>
    )
}

function RealTimeDepositItem({ list }: { list: RealTimeDepositListInterface; }) {
    // const alphabetNumberArr = getAlphabetNumberArr();
    //
    // let dummyId = "";
    // for(let i=0; i<rand(2, 8); i++){
    //     const randomValue = rand(0, 35)
    //     dummyId += alphabetNumberArr[randomValue]
    // }
    // console.log(dummyId)
    return (
        <div className={`realtime-deposit-items`}>
            <div>{list.kind}</div>
            <div>{list.user}</div>
            <div>{with_comma(list.amount)}</div>
            <div>{moment(list.processed_at).format('YYYY-MM-DD')}</div>
        </div>
    )
}




interface RealtimeJackpotInterface {
    "username": string,
    "nickname": string,
    "game_title": string,
    "win": number,
    "odds": number,
    "link": string
}
function RealtimeJackPotList() {
    const { User } = useContext(UserContext)
    const { SetLoginPop } = useContext(actionContext)

    const [jackpotList, setJackpotList] = useState<RealtimeJackpotInterface[]>()
    const [replayShow, SetReplayShow] = useState<boolean>(false)
    const [replayLink, setReplayLink] = useState<string>("")
    // const depositCostTemplate = [10000, 50000, 100000, 500000]

    function updateList() {
        api(`/api/game/jackpots/`)
            .then(res => res.json())
            .then((data: RealtimeJackpotInterface[]) => {
                setJackpotList(data)
            })
    }
    useEffect(() => {
        updateList()
    }, [])
    useInterval(() => {
        updateList()
    }, 60000)

    return (
        <div className={'list-layout realtime-deposit-layout'}>
            <div className={'frame'}></div>
            <header>금주의 잭팟 <span>TOP</span></header>
            {
                jackpotList
                    ? <Swiper
                        direction={'vertical'}
                        // spaceBetween={5}
                        autoplay={{
                            delay: 1500,
                            pauseOnMouseEnter: true
                        }}
                        freeMode={true}
                        loop={jackpotList.length > 5 ? true : false}
                        slidesPerView={4}
                        className={'list-main realtime-deposit-list'}
                        modules={[Autoplay]}
                    >
                        {
                            jackpotList.map((list, index) => {
                                const oddEven = index % 2 ? `odd` : `even`
                                return (
                                    <SwiperSlide key={index} className={`list-item ${oddEven}`}>
                                        <RealTimeJackpotItem list={list}
                                            User={User}
                                            SetLoginPop={SetLoginPop}
                                            SetReplayShow={SetReplayShow}
                                            setReplayLink={setReplayLink} />
                                    </SwiperSlide>
                                )
                            })
                        }
                        {
                            jackpotList.length > 5 && jackpotList.length < 10
                                ? jackpotList.map((list, index) => {
                                    const oddEven = index % 2 ? `odd` : `even`
                                    return (
                                        <SwiperSlide key={index} className={`list-item ${oddEven}`}>
                                            <RealTimeJackpotItem list={list}
                                                User={User}
                                                SetLoginPop={SetLoginPop}
                                                SetReplayShow={SetReplayShow}
                                                setReplayLink={setReplayLink} />
                                        </SwiperSlide>
                                    )
                                })
                                : <></>
                        }
                    </Swiper>
                    : <div className={'list-main realtime-deposit-list'}>
                        <Player src={loading}
                            autoplay
                            loop
                            style={{ width: "50%", height: "50%" }}
                        ></Player>
                    </div>
            }
            <ReplayModalIframe link={replayLink}
                replayShow={replayShow}
                SetReplayShow={SetReplayShow} />
        </div>
    )
}

function RealTimeJackpotItem({ list, User, SetLoginPop, SetReplayShow, setReplayLink }:
    {
        list: RealtimeJackpotInterface;
        User: PrivateUser;
        SetLoginPop: Function;
        SetReplayShow: Function;
        setReplayLink: Function;
    }) {

    function openReplay(link: string) {
        if (User?.is_authenticated) {
            SetReplayShow(true)
            setReplayLink(link)
        } else {
            SetLoginPop()
        }
    }
    return (
        <div className={`realtime-jackpot-items`}>
            <div>{list.username}</div>
            <div>{list.game_title}</div>
            <div>{with_comma(list.win)}</div>
            <div>
                X{with_comma(list.odds)}배
                <span onClick={e => openReplay(list.link)}>R</span>
            </div>
        </div>
    )
}